import React, { useEffect, useRef, useState } from "react"
import DataStore, { Screens } from "../dataStore/DataStore"
import { useLocation, useHistory } from "react-router-dom"
import busIcon from "../../assets/icons/ico_share_bus.svg"
import vvsIcon from "../../assets/icons/ico_vvs.svg"

import "./shareResultComponent.css"
import { Equivalence, EquivalenceMainType, EquivalenceTypes } from "../model/Equivalence"

interface IShareResult {}

function getUrlParameter(query: string, name: string): string {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]")
  let regex = new RegExp("[\\?&]" + name + "=([^&#]*)")
  let results = regex.exec(query)
  return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "))
}

const ShareResultComponent: React.FunctionComponent<IShareResult> = (props) => {
  const dataStore = DataStore.useStore()
  var searchQuery = useLocation().search
  const shareCard: any = useRef(HTMLDivElement)
  const history = useHistory()

  function findEquivalences(value: number, firstEqId: number, secondEqId: number): Equivalence[] {
    var possibleEquivalences = Equivalence.getEquivalenceTypesForMainType(EquivalenceMainType.co2)

    var firstEquivalenceType: EquivalenceTypes = possibleEquivalences[firstEqId]

    var firstValue = Equivalence.equivalenceValueMap.get(firstEquivalenceType) ?? 1
    var firstComparisonValue = Math.round(value / firstValue)
    var firstEquivalence = new Equivalence(firstEquivalenceType, firstComparisonValue)

    var secondEquivalenceType = possibleEquivalences[secondEqId]

    var secondValue = Equivalence.equivalenceValueMap.get(secondEquivalenceType) ?? 1
    var secondComparisonValue = Math.round(value / secondValue)
    var secondEquivalence = new Equivalence(secondEquivalenceType, secondComparisonValue)

    return [firstEquivalence, secondEquivalence]
  }

  function generateImage() {
    let dom: any = []
    dom.push(
      <div className="share-card-wrapper" ref={shareCard}>
        <div className="share-card">
          <div className="share-title">Mit dem VVS spare ich</div>
          <div className="share-value-holder">
            <div className="share-value">
              {new Intl.NumberFormat("de-DE").format(Math.round(Number.parseFloat(state.co2Save)))} kg CO2
            </div>
            <img className="share-bus-icon" src={busIcon}></img>
          </div>
          <div className="share-subtitle">im Vergleich zum Auto</div>
          <div className="share-equivalences-wrapper">
            <div className="share-equivalence-title">Wusstest Du?</div>
            <div className="share-equivalence-subtitle">Diese Menge CO2 entspricht:</div>

            <div className="equivalence-layout">
              <div className="equivalence-icon-layout">
                <img className="icon" src={state.firstEq.icon} alt="" />
                <img className="equal-icon" src={state.firstEq.equalIcon} alt="" />
              </div>
              <div className="equivalence-text-layout">
                <div className="equivalenceText">
                  {new Intl.NumberFormat("de-DE").format(state.firstEq.comparisonValue)}
                </div>
                <div className="equivalenceSubText">{state.firstEq.message}</div>
              </div>
            </div>

            <div className="equivalence-layout">
              <div className="equivalence-icon-layout">
                <img className="icon" src={state.secondEq.icon} alt="" />
                <img className="equal-icon" src={state.secondEq.equalIcon} alt="" />
              </div>

              <div className="equivalence-text-layout">
                <div className="equivalenceText">
                  {new Intl.NumberFormat("de-DE").format(state.secondEq.comparisonValue)}
                </div>
                <div className="equivalenceSubText">{state.secondEq.message}</div>
              </div>
            </div>
          </div>
          <img className="vvs-icon" src={vvsIcon}></img>
        </div>
        <div
          className="home-page-button"
          onClick={() => {
            history.push("/")
          }}
        >
          &gt; Jetzt meine Ersparnis berechnen{" "}
        </div>
      </div>
    )

    return dom
  }

  useEffect(() => {
    var co2Save = getUrlParameter(searchQuery, "co2save")
    var firstEq = getUrlParameter(searchQuery, "firstEq")
    var secondEq = getUrlParameter(searchQuery, "secondEq")
    var equivalences = findEquivalences(
      Number.parseFloat(co2Save) * 1000,
      Number.parseInt(firstEq),
      Number.parseInt(secondEq)
    )

    setState((prevstate) => ({
      ...prevstate,
      firstEq: equivalences[0],
      secondEq: equivalences[1],
      co2Save: co2Save
    }))
  }, [searchQuery])

  const [state, setState] = useState({
    co2Save: "",
    firstEq: new Equivalence(EquivalenceTypes.food, 0),
    secondEq: new Equivalence(EquivalenceTypes.food, 0)
  })

  return <>{<div className="share-result-page">{generateImage()}</div>}</>
}
export default ShareResultComponent
